import React, { useCallback } from "react";
import ReusableTable from "./ReusableTable";
import { fetchSubscribers } from "../util/fetchUserUtil";

export const TelecomMasters = () => {
  const fetchData = useCallback(async (postData) => {
    try {
      return await fetchSubscribers(postData, "masters");
    } catch (error) {
      const errorMessage =
        error?.response?.data?.data?.errorMessage ||
        error.message ||
        "An unknown error occurred";
      throw new Error(errorMessage);
    }
  }, []);

  const actionButtonsMeta = [
    {
      name: "New Master",
      action: "create_telecom_master",
    },
  ];

  return (
    <div className="flex flex-col ">
      <ReusableTable
        key={"telecom_masters"}
        tableType={"telecom_masters"}
        tableName={"Masters"}
        needGlobalFilter={true}
        needColumnFilter={true}
        needPagination={true}
        onStateChange={fetchData}
        actionButtonsMeta={actionButtonsMeta}
        isExtendingReusableColumns={true}
      />
    </div>
  );
};

export default TelecomMasters;
